<div class="datepicker-container">
  <form [formGroup]="datePickerForm">
    <mat-form-field (click)="pickerStart.open()">
      <input
        matInput
        class="general-hide"
        [matDatepicker]="pickerStart"
        placeholder="Fecha de inicio"
        formControlName="startDate"
        [max]="maxStartDate"
      />
      <div class="parsed-date">{{ daterangeLabel.startDate }}</div>
      <img
        alt="start date"
        class="calendar-arrow"
        src="/images/icons/atm-black-arrow.svg"
      />
      <mat-datepicker
        #pickerStart
        (closed)="handlePickerClosed('startDate')"
      ></mat-datepicker>
    </mat-form-field>

    <mat-form-field (click)="pickerEnd.open()">
      <input
        matInput
        readonly
        placeholder="Fecha de fin"
        class="general-hide"
        [matDatepicker]="pickerEnd"
        [max]="maxEndDateDate"
        [min]="minEndDateDate"
        formControlName="endDate"
      />
      <div class="parsed-date">{{ daterangeLabel.endDate }}</div>
      <img
        alt="end date"
        class="calendar-arrow"
        src="/images/icons/atm-black-arrow.svg"
      />
      <mat-datepicker
        #pickerEnd
        (closed)="handlePickerClosed('endDate')"
      ></mat-datepicker>
    </mat-form-field>
  </form>
</div>
